import { IconType } from '../components/icons/icon-type';
import DocIcon from '../components/icons/images/doc-icon.png';
import PdfIcon from '../components/icons/images/pdf-icon.png';
import PngIcon from '../components/icons/images/png-icon.png';
import JpgIcon from '../components/icons/images/jpg-icon.png';

export type FileDisplayInfo = {
  types: string[];
  label: string;
  shortLabel: string;
  icon: IconType;
  imagePath: string;
};

const FileTypes: FileDisplayInfo[] = [
  {
    icon: IconType.FileDoc,
    imagePath: DocIcon,
    label: 'Document',
    shortLabel: 'DOC',
    types: ['application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  },
  {
    icon: IconType.FilePdf,
    imagePath: PdfIcon,
    label: 'PDF Document',
    shortLabel: 'PDF',
    types: ['application/pdf'],
  },
  {
    icon: IconType.FilePng,
    imagePath: PngIcon,
    label: 'Image',
    shortLabel: 'PNG',
    types: ['image/png'],
  },
  {
    icon: IconType.FileJpg,
    imagePath: JpgIcon,
    label: 'Image',
    shortLabel: 'JPG',
    types: ['image/jpeg', 'image/jpg'],
  },
];

const genericFileDisplayInfo: FileDisplayInfo = {
  icon: IconType.Generic,
  imagePath: '',
  label: 'Generic',
  shortLabel: 'Generic',
  types: [],
};

const fileDisplayInfo = (type: string) => {
  const displayInfo = FileTypes.find(
    (o) => o.types.includes(type),
  );

  return displayInfo || genericFileDisplayInfo;
};

export default fileDisplayInfo;
